import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal, showAlert } from '../../../../app/store/reducers/AppSlice'
import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { BpCheckbox } from '../../../../shared/components/forms/checkbox/BpCheckbox'
import { NavLink } from 'react-router-dom'
import styles from '../../../review/widgets/review-filters/ReviewFilters.module.scss'
import { usePostTmInfringementsSubmitMutation } from '../../../../app/api'

interface TrademarkInfringementsConfirmModalProps {
  project: string
  infringements: any[]
}

export const TrademarkInfringementsConfirmModal = ({
  project,
  infringements,
}: TrademarkInfringementsConfirmModalProps) => {
  const { t } = useTranslation()
  const [forwardReplies, setForwardReplies] = useState(false)
  const dispatch = useAppDispatch()

  const [submit, { isLoading }] = usePostTmInfringementsSubmitMutation()

  const handleSubmit = () => {
    submit({
      body: {
        project_id: project as unknown as number,
        infringement_ids: infringements.map((infringement) => infringement.infringement_id),
        forward_replies_to_my_email: forwardReplies,
      },
    }).then((response: any) => {
      dispatch(hideModal())
      if (response.data?.success) {
        dispatch(
          showAlert({
            message: t('pages.trademarkInfringements.complaintSubmitted'),
            timeout: 5000,
            type: 'success',
          }),
        )
      } else {
        dispatch(
          showAlert({
            message: t('pages.trademarkInfringements.complaintSubmitFailed'),
            timeout: 5000,
            type: 'error',
          }),
        )
      }
    })
  }

  return (
    <div className={'flex flex-col'}>
      <h3
        className={
          'flex min-h-[55px] w-full items-center border-b-[3px] border-b-[#00326D]/[.02] px-[24px] text-[20px] font-medium'
        }
      >
        {t('pages.trademarkInfringements.confirmSubmission')}
      </h3>
      <div className={'flex flex-col gap-[16px] px-[24px] pt-[18px] pb-[16px]'}>
        {infringements.length > 3 ? (
          <p className={'text-focus-500'}>
            <Trans
              i18nKey='pages.trademarkInfringements.confirmSubmissionModalDescriptionCount'
              values={{ count: infringements.length }}
            >
              <span className={'font-semibold'} />
            </Trans>
          </p>
        ) : (
          <div className={'flex flex-col gap-[8px]'}>
            <p className={'text-focus-500'}>
              {t('pages.trademarkInfringements.confirmSubmissionModalDescription')}
            </p>
            <ul className={'list-disc pl-[16px] text-focus-500'}>
              {infringements.map(({ domain, country }) => (
                <li key={domain}>
                  <div className={'flex items-center gap-[4px]'}>
                    <span>{domain},</span>
                    <div className={'flex items-center gap-[4px]'}>
                      <div className='relative h-[30px] w-[30px] overflow-hidden rounded-full border-2 border-aqua/[.1]'>
                        <span
                          className={`fi fis fi-${country.code} absolute top-0 left-0 block !h-[26px] !w-[26px]`}
                        />
                      </div>
                      {country.name}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
        <BpCheckbox
          checked={forwardReplies}
          defaultChecked={false}
          label={t('pages.trademarkInfringements.forwardReplies')}
          onChange={(e) => setForwardReplies(e.target.checked)}
        />
      </div>
      <div
        className={
          'flex w-full gap-[12px] border-t-[3px] border-t-[#00326D]/[.02] px-[24px] py-[24px]'
        }
      >
        <BpButton className={'uppercase'} disabled={isLoading} onClick={() => handleSubmit()}>
          {t('buttons.confirm')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </div>
  )
}
